<template>
    <div>
        <div v-if="!showInc" class="table-container fr-table">
            <b-table-simple striped hover bordered>
                <thead>
                <b-tr>
                    <b-th>№ Таблицы</b-th>
                    <b-th>Название таблицы</b-th>
                    <b-th>Дата изменений</b-th>
                    <b-th>Автор изменений</b-th>
                    <b-th>Примечание</b-th>
                </b-tr>
                </thead>
                <b-tbody>
                    <b-tr v-for="(field, index) in formApp6" :key="index">
                        <b-th class="text-center">
                            <b-link @click="getTableLink(field.table_number, field.table_name_ru)" href="#">
                                {{ field.table_number }}
                            </b-link>
                        </b-th>
                        <b-th>
                            <b-link @click="getTableLink(field.table_number, field.table_name_ru)" href="#" class="text-decoration-none">
                                {{ field.table_name_ru }}
                                <span v-if="checkDataList.some(item => String(item.table_num) === String(field.table_number))"
                                      class="warning-icon"
                                      title="Внимание! Форма не соответствует контролю"> ⚠</span>
                            </b-link>
                        </b-th>
                        <template v-if="filteredFormList(field.table_number).length > 0">
                            <b-td v-for="(field, index) in filteredFormList(field.table_number)" :key="index">
                                {{ formatDate(field.update_date) }}
                            </b-td>
                            <b-td v-for="(field, index) in filteredFormList(field.table_number)" :key="index + '-user'">
                                {{ field.user_id_name }}
                            </b-td>
                        </template>
                        <template v-else>
                            <b-td></b-td>
                            <b-td></b-td>
                        </template>
                        <b-th>
                            <span class="modal-call" @click="openModal(field.table_number)">
                                <i v-if="filteredFormList(field.table_number).length > 0 && filteredFormList(field.table_number)[0].comments_text !== null"
                                   class="csi-icon csi-icon-chat"></i>
                                <i v-else
                                   :class="['icon', 'icon-plus-circle', { 'disabled-icon': !actualVersion }]"
                                   :style="{ opacity: actualVersion ? 1 : 0.5 }">
                                </i>
                            </span>
                        </b-th>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
            <loading
                :active="loading"
                is-full-screen
                spinner="bar-fade-scale"
                color="#6495ED"
            />
        </div>
        <b-modal v-model="showModal"
                 modal-class="fr-modal-comment"
                 title="Примечание:"
                 centered>
            <div class="comments-content">
                <div class="comments-content" v-if="filteredComments.length > 0">
                    <div class="comment-block" v-for="(comment, index) in filteredComments" :key="index">
                        <p class="label">
                            <span class="mr-1">{{ comment.comments_date }}</span>
                            <span>{{ comment.user_name }}</span></p>
                        <b-form-textarea v-model="comment.comments_text"
                                         @input="updateCommentText(comment.comments_text)"></b-form-textarea>
                    </div>
                </div>
                <div class="comments-content" v-else>
                    <div class="comment-block">
                        <p class="label"></p>
                        <b-form-textarea v-model="comments_text"></b-form-textarea>
                    </div>
                </div>
            </div>
            <template #modal-footer>
                <div class="modal-footer-content">
                    <div v-if="actualVersion && (access_level === 2 || access_level === 3)" class="buttons">
                        <b-button variant="light" @click="CancelComment">Отменить</b-button>
                        <b-button variant="success" @click="SaveComment">Сохранить</b-button>
                    </div>
                    <div class="comments-content" v-if="filteredComments.length > 0"
                         style="margin-right: 0; cursor: pointer;">
                        <div class="comment-block" v-for="(comment, index) in filteredComments" :key="index">
                            <p v-if="actualVersion && [2, 3].includes(access_level)"
                               class="label" @click="clearComment(comment)"><i class="icon icon-close"></i> ОЧИСТИТЬ</p>
                        </div>
                    </div>
                    <div class="comments-content" v-else style="margin-right: 0; cursor: pointer;">
                        <div class="comment-block">
                            <p v-if="actualVersion && [2, 3].includes(access_level)"
                               class="label" @click="clearComment(comments_text)"><i class="icon icon-close"></i>
                                ОЧИСТИТЬ</p>
                        </div>
                    </div>
                </div>
            </template>
        </b-modal>
        <forecast-app6-tables v-if="showInc"
                              ref="tablesRef"
                              :table_number="table_number"
                              v-bind="forecastProps"
                              source="app6"
                              :checkDataList="getCheckData('PR6')"
        ></forecast-app6-tables>
    </div>
</template>
<script>

import VueElementLoading from "vue-element-loading";
import ForecastApp6Tables from "@/modules/forecast-reporting/ForecastApp6Tables";
import moment from "moment/moment";
import {Ax} from "@/utils";

export default {
    name: 'forecast-uo-app6',
    components: {
        'loading': VueElementLoading, ForecastApp6Tables
    },
    props: {
        year: Number,
        region: String,
        version: String,
        abp: Number,
        dataType: Number,
        region_name: String,
        version_name: String,
        obl: String,
        actualVersion: Boolean,
        access_level: Number,
        showInc: Boolean,
        table_num: String,
        checkDataList: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            loading: false,
            open: false,
            tableFields: [
                {
                    key: 'code',
                    label: '№',
                    rowspan: 2
                },
                {
                    key: 'pkfo_2_code',
                    label: 'Строка из прогнозного консолидированного отчета о результатах финансовой деятельности',
                    rowspan: 2
                },
                {
                    key: 'spf',
                    label: 'Специфика экономической классификации Единой бюджетной классификации ',
                    rowspan: 2
                },
                {
                    key: 'name_ru',
                    label: 'Сумма по строке прогнозного отчета о результатах финансовой деятельности',
                    rowspan: 2
                },
                {
                    key: 'value',
                    label: 'Оценка*, ТЫС.ТЕҢГЕ',
                    rowspan: 1
                },
                {
                    key: 'forecast',
                    label: 'Прогноз, ТЫС.ТЕҢГЕ',
                    colspan: 3
                }],
            formApp6: [],
            tableCheck: false,
            table_number: null,
            table_name: null,
            repdate: null,
            openRows: {},
            inputValues: [],
            showModal: false,
            filteredComments: [],
            comments_text: '',
            previousCommentText: []

        }
    },
    async mounted() {
        await this.getApp6Forms();
        await this.LoadApp6Form();
    },
    computed: {
        filteredFormList() {
            return (num) => this.formList.filter(item => item.table_id === num);
        },
        forecastYears() {
            return [this.year - 1, this.year, this.year + 1, this.year + 2];
        },
        forecastProps() {
            return {
                year: this.year,
                region: this.region,
                region_name: this.region_name,
                version: this.version,
                version_name: this.version_name,
                dataType: this.dataType,
                obl: this.obl,
                actualVersion: this.actualVersion,
                access_level: this.access_level
            };
        }
    },
    methods: {
        getCheckData(formName) {
            if (!this.checkDataList) return [];

            return this.checkDataList.filter(item => {
                if (formName === 'PR6') {
                    return item.agreed_form?.startsWith('PR6');
                }
                return item.agreed_form === formName;
            });
        },
        callTablesMethod() {
            this.$refs.tablesRef?.LoadApplyButton();
        },
        callSaveMethod(table) {
            if (table === '1.13'){
                this.$refs.tablesRef?.SaveDataMovement();
            } else if (table === '1.18'){
                this.$refs.tablesRef?.SaveDataPKFO3();
            } else if (table === '1.22' || table === '1.23' || table === '1.24' ||
                       table === '1.25' || table === '1.26' || table === '1.27'){
                this.$refs.tablesRef?.SaveDataBalance();
            } else if (table === '1.20') {
                this.$refs.tablesRef?.SaveDataPKFO2();
            } else if (table === '1.30') {
                this.$refs.tablesRef?.SaveDataPKFO4();
            }
        },
        getTableLink(table_num, table_name) {
            this.table_number = table_num;
            this.table_name = table_name;
            this.$emit('open-inc', table_num, table_name);
        },
        formatDate(date) {
            if (date !== null){
                return new Date(date).toLocaleDateString('ru-RU', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric'
                });
            }
        },
        formatDecimal(child, field) {
            let value = child[field].toString();
            if (value.includes('.')) {
                value = value.replace(/(\.\d).*/, '$1'); // Keep only one digit after '.'
            }
            child[field] = value;
        },
        async LoadApp6Form() {
            this.loading = true;
            try {
                const response = await fetch(`/api-py/get_application6_tables`);
                if (response.status === 200) {
                    this.formApp6 = await response.json();
                }
            } catch (error) {
                this.makeToast('danger', 'Ошибка загрузки форм Приложения 6', error.toString());
            }
            this.loading = false;
        },
        async getApp6Forms() {
            this.isLoad = true;
            this.previousCommentText = [];
            if (this.region !== null && this.dataType !== null && this.year !== null && this.version !== null) {
                this.formList = [];
                this.curParams = {
                    cur_year: this.year,
                    region: this.region,
                    data_type: this.dataType,
                    variant: this.version
                }
                const response = await fetch(`/api-py/get_appendix_6_forms/` + JSON.stringify(this.curParams));
                const data = await response.json();
                this.formList = data.result;
                const tableNum = Array.from({ length: 30 }, (_, i) => `1.${i + 1}`);
                for (const num of tableNum) {
                    const filteredList = this.formList.filter(item => item.table_id === num);
                    for (const item of filteredList) {
                        this.previousCommentText.push({
                            table_id: item.table_id,
                            comments_text: item.comments_text,
                        });
                        if (item.user_id !== null){
                            await this.loadUserNames(item.user_id, 'user_id', num);
                        }
                    }
                }
            }
            this.isLoad = false;
        },
        openModal(code) {
            if (this.actualVersion){
                this.table_number = code;
                this.comments_text = '';
                this.codeForm = code;
                this.filteredComments = this.formList.filter(comment => comment.table_id === code);

                if (this.filteredComments.length > 0) {
                    this.loadUserNames(this.filteredComments[0].comments_user_id, 'comment', code);
                }

                this.showModal = true;
            }
        },
        CancelComment(){
            this.showModal = false;
        },
        updateCommentText(newText) {
            this.comments_text = newText;
        },
        clearComment(comment){
            if (this.filteredComments.length > 0){
                comment.comments_text = '';
                this.comments_text = '';
            } else {
                this.comments_text = '';
            }
        },
        async SaveComment() {
            const checkComment = this.previousCommentText.filter(item => item.code === this.codeForm);
            if (checkComment.length === 0 || checkComment[0].comments_text !== this.filteredComments[0].comments_text){
                this.comment = [];
                const item = Object.assign({});
                this.$set(item, 'table_id', this.table_number);
                this.$set(item, 'cur_year', this.year);
                this.$set(item, 'region_code', this.region);
                this.$set(item, 'data_type', this.dataType);
                this.$set(item, 'budget_variant', this.version);
                this.$set(item, 'comments_text', this.comments_text);
                this.$set(item, 'comments_date', moment().format('YYYY-MM-DD'));
                this.$set(item, 'comments_user_id', this.$store.getters.user_uuid);
                this.isLoad = true;
                this.comment.push(item);
                try {
                    const response = await fetch('/api-py/add_comment_to_appendix_6_forms', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json;charset=utf-8'
                        },
                        body: JSON.stringify(this.comment)
                    });
                    const result = await response.json();
                    if (response.status === 200 && result.result === 'success') {
                        this.showModal = false;
                        this.isSave = false;
                        this.makeToast('success', 'Сообщение', 'Примечание сохранено');
                        await this.getApp6Forms();
                        this.comments_text = '';
                    } else {
                        if (result.result === 'error') {
                            throw 'Ошибка сохранения данных.';
                        }
                    }
                } catch (e) {
                    this.makeToast('danger', 'Предупреждение', e.toString());
                } finally {
                    this.isLoad = false;
                }
            }
        },
        async loadUserNames(user_id, field, table_id) {
            try {
                const response = await fetch(`/api-py/get-realm-user/${user_id}`);
                if (response.status === 200) {
                    const data = await response.json();
                    if (field === 'comment') {
                        this.filteredComments.forEach(comment => {
                            this.$set(comment, 'user_name', data.lastName + ' ' + data.firstName);
                        });
                    }
                    if (field === 'user_id') {
                        this.formList.forEach(code => {
                            if (code.user_id === user_id && code.table_id === table_id) {
                                this.$set(code, 'user_id_name', data.lastName + ' ' + data.firstName);
                            }
                        });
                    }
                } else {
                    if (field === 'comment') {
                        this.filteredComments.forEach(comment => {
                            this.$set(comment, 'user_name', '');
                        });
                    }
                    if (field === 'user_id') {
                        this.formList.forEach(code => {
                            this.$set(code, 'user_id_name', '');
                        });
                    }
                }
            } catch (error) {
                if (field === 'comment') {
                    this.filteredComments.forEach(comment => {
                        this.$set(comment, 'user_name', '');
                    });
                }
                if (field === 'user_id') {
                    this.formList.forEach(code => {
                        this.$set(code, 'user_id_name', '');
                    });
                }
            }
        },
        makeToast(variant, title, tostbody) {
            this.$bvToast.toast(tostbody, {
                title: title,
                variant: variant,
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
                appendToast: true
            });
        },
    }
}
</script>
